// Util function to mount and unmount the appopintment modal based on the type
import { createApp } from 'appointmentModalApp/vue3'
import BookAppointment from 'appointmentModalApp/BookAppointment'
import ViewAppointment from 'appointmentModalApp/ViewAppointment'
import { useAppContext } from '../pmd/composition/useAppContext'
import firebase from 'firebase/compat/app'
import store from '../store'
import {  Location } from '@/models'
import AuthUser from '../models/auth_user'
import lodash from 'lodash'

let bookAppointmentApp: any = {}
let viewAppointmentApp: any = {}

// Function to mount a modal component
function mountAppointmentModal(mountId: string, configuration: any) {
  // Unmount any existing instance of the modal
  if (bookAppointmentApp?.unmount) bookAppointmentApp.unmount()
  if (viewAppointmentApp?.unmount) viewAppointmentApp.unmount()

  const { mountAppContext } = useAppContext()
  const showModal = true
  let Component
  switch (mountId) {
    case 'BookAppointment':
      Component = BookAppointment
      break
    case 'ViewAppointment':
      Component = ViewAppointment
      break
    default:
      Component = null
  }

  const appointmentModalApp = createApp(Component, {
    ...configuration,
    showModal: showModal, // Adding the showModal flag to the configuration
  })

  mountAppContext({ appointmentModalApp })
  appointmentModalApp.mount(`#${mountId}`)

  // Store the app instance in the corresponding variable
  if (mountId === 'BookAppointment') {
    bookAppointmentApp = appointmentModalApp
  } else if (mountId === 'ViewAppointment') {
    viewAppointmentApp = appointmentModalApp
  }
}

// Function to unmount a modal component
function unmountAppointmentModal(mountId: string) {
  const appToUnmount =
    mountId === 'BookAppointment' ? bookAppointmentApp : viewAppointmentApp
  if (appToUnmount?.unmount) {
    appToUnmount.unmount()
  }
}


function camelize(obj) {
  if (lodash.isObject(obj)) {
    if (lodash.isArray(obj)) {
      return obj.map(item => camelize(item));
    } else {
      const newObj = {};
      lodash.forEach(obj, (value, key) => {
        const camelKey = lodash.camelCase(key);
        newObj[camelKey] = camelize(value);
      });
      return newObj;
    }
  }
  return obj;
}

async function getCalendarData(locationId: string) {
  const location = await new Location(
    await store.dispatch('locations/getCurrentLocation', locationId)
  )
  const tokenId = await firebase.auth().currentUser?.getIdToken()
  const auth = new AuthUser(await store.dispatch('auth/get'))
  const userId = firebase.auth().currentUser?.uid || store.state.user.id
  const userType = store.state.user?.user?.type
  const userRole = store.state.user?.user?.role
  const calendars = store.state.calendars.calendars
  const filteredCalendars = calendars.map((calendar: any) => camelize(calendar))
  const groups = store.state.teams.teams
  const filteredGroups = groups.map((group: any) => camelize(group))
  const users = store.state.users.users
  const fileteredUsers = users.map((user: any) => camelize(user))
  const loggedInUserInfo = camelize(store.getters['user/get'])
  let whitelabelUrl = ''
  if (!whitelabelUrl) {
    whitelabelUrl = window.location.origin
  }
  const data = {
    name: 'calendar-app',
    locationId: location._id,
    tokenId: tokenId,
    apiKey: location.apiKey,
    disableContactTimezone: location.disableContactTimezone,
    authApiKey: auth.apiKey,
    userId: userId,
    userType: userType,
    userRole: userRole,
    timeZone: location.timezone,
    locale:
      store.state.user.user.platformLanguage ||
      location.localeSettings.platform,
    company: {
      plan: store.state.company?.company?.stripe_active_plan,
      id: store.state.company?.company?.id,
    },
    whitelabelUrl: whitelabelUrl,
    recurringEventsEnabled: true,
    calendars: filteredCalendars,
    groups: filteredGroups,
    users: fileteredUsers,
    loggedInUserInfo: loggedInUserInfo
  }
  return data
}

export { mountAppointmentModal, unmountAppointmentModal, getCalendarData }
